import axios from 'axios';
import { GET_SUBSCRIPTION_TOKEN } from './api';
import { getLink } from 'helpers/route';

export async function getSubscriptionToken({ id, hasSubscription }) {
	if (!id || !hasSubscription) return null;

	try {
		const url = getLink(GET_SUBSCRIPTION_TOKEN, { companyId: id });

		const {
			data: { token },
		} = await axios.get(url);

		return token;
	} catch (e) {
		console.log(e, 'error');
	}
}
